import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Loading, ContratosCardNav, CardStatus, BarGraph } from "../components"
import Layout from "../views/Layout"
import * as ApiHelper from "../ApiHelper"
import Util from "../Util"
class Dashboard extends Component {
  constructor() {
    super()
    this.getDashboardData.bind(this)
    this.state = {
      numeroDeContratos: "",
      somaValoresGlobais: "",
      somaBaixas: "",
      contratosProximosDoVencimento: "",
      proximosAVencerCount: "",
      proximosAVencer: [],
      valoresGastos: [],
      maxGastoMensal: 0,
      maioresFornecedores: [],
      contratosParados: [],
      ultimasBaixas: [],
      showDash: false
    }
  }
  componentWillMount() {
    this.getDashboardData()
  }
  getDashboardData() {
    ApiHelper.getDashboardData(data => {
      if (data) {
        var valorBaixas = parseFloat(data.soma_baixas)
        this.setState({
          numeroDeContratos: data.contratos_count,
          proximosAVencer: data.contratos_a_vencer,
          proximosAVencerCount: data.contratos_a_vencer.length,
          somaValoresGlobais: Util.formatCurrency(data.soma_valores_globais),
          somaBaixas: Util.formatCurrency(valorBaixas),
          valoresGastos: data.gasto_mensal,
          maxGastoMensal: data.max_gasto_mensal,
          maioresFornecedores: data.maiores_contratados,
          contratosParados: data.sem_movimento,
          semFiscalizacao: data.sem_fiscalizacao,
          ultimasBaixas: data.ultimas_baixas,
          showDash: true
        })
      }
    })
  }

  render() {
    var gastoMensalLabels = Object.keys(this.state.valoresGastos)

    var valoresGastoMensal = []
    gastoMensalLabels.forEach(mes => {
      valoresGastoMensal.push(parseFloat(this.state.valoresGastos[mes]))
    })
    var values = [valoresGastoMensal]
    var gastoMensalMaxValue = this.state.maxGastoMensal
    return (
      <Layout tabActive="Dashboard">
        {this.state.showDash === false && <Loading />}
        {this.state.showDash === true && (
          <div>
            <CardStatus
              link="/contratos"
              backgroundColor="as-blue"
              linkLabel="Ver contratos"
              linkIcon="forward"
              icon="description"
              data={this.state.numeroDeContratos}
              category="Número de contratos cadastrados"
            />

            <CardStatus
              link="/contratos"
              backgroundColor="as-blue"
              linkLabel="Ver contratos"
              linkIcon="forward"
              icon={"attach_money"}
              data={this.state.somaValoresGlobais}
              category={"Valor total em contratos"}
            />
            <CardStatus
              link="/contratos"
              backgroundColor="as-blue"
              linkLabel="Ver contratos"
              linkIcon="forward"
              icon={"attach_money"}
              data={this.state.somaBaixas}
              category={"Valor total das baixas"}
            />
            <CardStatus
              link="/contratos"
              backgroundColor="as-blue"
              linkLabel="Ver contratos"
              linkIcon="forward"
              icon="description"
              data={this.state.proximosAVencerCount}
              category={"Número de contratos próximos do vencimento"}
            />
            <BarGraph
              title="Gasto mensal"
              category="Soma dos valores das baixas de cada mês"
              legenda="Dados relacionados ao período de 12 meses anteriores ao mês atual"
              labels={gastoMensalLabels}
              values={values}
              max={gastoMensalMaxValue}
              backgroundColor={"red"}
            />
            <ContratosCardNav
              data={[
                this.state.maioresFornecedores,
                this.state.ultimasBaixas,
                this.state.semFiscalizacao,
                this.state.contratosParados,
                this.state.proximosAVencer
              ]}
              backgroundColor={"purple"}
            />
          </div>
        )}
      </Layout>
    )
  }
}

export default withRouter(Dashboard)



// WEBPACK FOOTER //
// ./src/views/Dashboard.js